import { Playground } from '@modules/uilab/components';
import { Button, ButtonModifiers, ButtonTheme } from '@components/Button';
import { Checkbox } from '@components/Checkbox';
import { Input } from '@components/Input/Input';
import { OptionType, Select } from '@components/Select';

import style from './ButtonPage.module.scss';
import '@components/mixins/commonStyles.scss';
import { CheckboxList } from '@components/CheckboxList';
import { OptionParams } from '@components/CheckboxList/CheckboxList';
import { CommonTestAttributes } from 'chaika-test-attributes';

export interface ButtonPageProps {
    redesign: boolean;
    withAddIcon: boolean;
    theme: OptionType;
    label: string;
    modifiers: ButtonModifiers[];
    themeOptions: OptionType[];
    modifiersOptions: OptionParams<ButtonModifiers>[];
    onRedesignChange(): void;
    onWithAddIconChangeChange(): void;
    onLabelChange(event: React.ChangeEvent<HTMLInputElement>): void;
    onThemeChange(params: OptionType, name?: string | undefined): void;
    onModifiersChange(selectedValues: ButtonModifiers[]): void;
}

export function ButtonPage({
    redesign,
    theme,
    modifiers,
    label,
    withAddIcon,
    themeOptions,
    modifiersOptions,
    onRedesignChange,
    onWithAddIconChangeChange,
    onLabelChange,
    onThemeChange,
    onModifiersChange,
}: ButtonPageProps) {
    return (
        <div className={style.root}>
            <div className={'font_h2'}>Button component</div>
            <div className={style.content}>
                <div className={style.controls}>
                    <div className={style.controlItem}>
                        <Checkbox
                            dataTest={CommonTestAttributes.Unknown}
                            label="redesign: boolean (optional)"
                            isChecked={redesign}
                            onChange={onRedesignChange}
                        />
                    </div>
                    <div className={style.controlItem}>
                        <Checkbox
                            dataTest={CommonTestAttributes.Unknown}
                            label="withAddIcon: boolean (optional)"
                            isChecked={withAddIcon}
                            onChange={onWithAddIconChangeChange}
                        />
                    </div>
                    <div className={style.controlItem}>
                        <Input
                            title="label: string (optional)"
                            value={label}
                            dataTest={CommonTestAttributes.Unknown}
                            onChange={onLabelChange}
                        />
                    </div>
                    <div className={style.controlItem}>
                        <Select
                            title="theme?: ButtonTheme (optional)"
                            name="buttonThemes"
                            value={theme}
                            dataTest={CommonTestAttributes.Unknown}
                            options={themeOptions}
                            onChange={onThemeChange}
                        />
                    </div>
                    <div className={style.controlItem}>
                        <CheckboxList
                            title="modifiers?: ButtonModifiers[] (optional)"
                            selectedValues={modifiers}
                            options={modifiersOptions}
                            onChange={onModifiersChange}
                        />
                    </div>
                </div>
                <Playground>
                    <Button
                        dataTest={CommonTestAttributes.Unknown}
                        theme={theme.value as ButtonTheme}
                        modifiers={modifiers as ButtonModifiers[]}
                        label={label}
                        withAddIcon={withAddIcon}
                    />
                </Playground>
            </div>
        </div>
    );
}
